import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-returns-refunds',
  templateUrl: './returns-refunds.component.html',
  styleUrls: ['./returns-refunds.component.css']
})
export class ReturnsRefundsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
